import PropTypes from 'prop-types';

import './custom-charts.scss';
import { acronymInterpreter } from '../../../../helpers/functions';

const COLORS = {
  yellow: '#FFE600',
  blue: '#0021D1',
  red: '#FF0000',
  green: '#008D50',
  purple: '#DB00FF',
  lightblue: '#49C7EF',
  orange: '#FF6B00',
  petrol: '#009E9E',
  lightgreen: '#4CAF50',
  peachyellow: '#FFC645',
  burgundy: '#BA0021',
}

const colorsShort = (acronym) => {
  const allColors = {
    'R': COLORS.red,
    'AM': COLORS.yellow,
    'V': COLORS.green,
    'AZ': COLORS.blue,
  };
  return allColors[acronym] || COLORS.yellow;
};

const colors = (acronym) => {
  const allColors = {
    'DES': COLORS.petrol,
    'LID': COLORS.purple,
    'INV': COLORS.lightgreen,
    'EST': COLORS.orange,
    'REC': COLORS.peachyellow,
    'AY': COLORS.burgundy,
    'PAZ': COLORS.lightblue,
  };
  return allColors[acronym] || COLORS.yellow;
};

const endTitle = ['Me muestro', 'Me comporto', 'Me motiva'];

const Charts = ({ data }) => {
  return (
    <div className="cc-all-charts-container">
      {data?.results &&
        <>
          {data?.results.map((e, index) => {
            if (e?.sectionScore.length > 1 && e?.sectionScore.length <= 4) {
              return (
                <div className="cc-ct-container">
                  <table>
                    <tbody>
                      <tr className="cc-ct-section">
                        <td className="cc-ct-title">{e?.sectionTitle || `T${index + 1}`}</td>
                        {e?.sectionScore.map((section, index) => (
                          <td className="cc-ct-bar-container" key={`table-5-section-${index}`}>
                            <div>
                              <div className="cc-ct-bar" style={{ backgroundColor: colorsShort(section?.indicatorAcronym), height: `${section?.DISC * 10 || 0}%` }} />
                            </div>
                          </td>
                        ))}
                        <td className="cc-ct-endtext">
                          <div>
                            {endTitle[index] || `datos ${index}`}
                          </div>
                        </td>
                      </tr>
                      <tr className="cc-ct-footer">
                        <td></td>
                        {e?.sectionScore.map((data) => <td >{`${acronymInterpreter(data?.indicatorAcronym)} ${data?.DISC.toFixed(1)}` || 'NN'}</td >)}
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )
            }
          })}
          <div className="cc-ct-container">
            <table>
              <tbody>
                {data?.results.map((e, index) => {
                  if (e?.sectionScore.length > 4 && e?.sectionScore.length <= 7) {
                    return (
                      <tr className="cc-ct-section" key={`table-7-${index}`}>
                        <td className="cc-ct-title">{e?.sectionTitle || `T${index + 1}`}</td>
                        {e?.sectionScore.map((section, index) => (
                          <td className="cc-ct-bar-container" key={`table-7-section-${index}`}>
                            <div>
                              <div className="cc-ct-bar" style={{ backgroundColor: colors(section?.indicatorAcronym), height: `${section?.DISC * 10 || 0}%` }} />
                            </div>
                          </td>
                        ))}
                        <td className="cc-ct-endtext">
                          <div>Me motiva</div>
                        </td>
                      </tr>
                    );
                  }
                })}
                <tr className="cc-ct-footer">
                  <td></td>
                  {data?.results[2]?.sectionScore.map((data) => <td >{`${data?.indicatorAcronym} ${data?.DISC.toFixed(1)}` || 'NN'}</td >)}
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </>}
      {!data?.results &&
        <div className="cc-ct-no-data">No hay resultados que mostrar</div>
      }
    </div>
  );
}

Charts.propTypes = {
  data: PropTypes.object,
};

const chartData = {
  "id": "ee6106d5-874f-47ea-97df-c8bc22262096",
  "testId": "8c874eb5-aad9-4cc9-8d6c-8ca13f1c82d4",
  "testName": "Índice de Comportamientos y Motivadores",
  "statusId": 4,
  "status": "Finished",
  "createdAt": "2023-01-19T19:46:32.193Z",
  "sentAt": "2023-01-19T19:46:35.492Z",
  "finishedAt": "2023-01-19T20:15:29.389Z",
  "results": [
    {
      "colorPair": {
        "colorPairs": "V - AZ",
        "indicatorAcronym1": "V",
        "indicatorAcronym2": "AZ"
      },
      "sectionID": "08945f63-a24c-489f-b30d-2531473f8792",
      "sectionScore": [
        {
          "DISC": 5.561,
          "LUSCHER": 6,
          "indicatorAcronym": "AM"
        },
        {
          "DISC": 6.061000000000001,
          "LUSCHER": 7,
          "indicatorAcronym": "AZ"
        },
        {
          "DISC": 2.5649999999999995,
          "LUSCHER": 3,
          "indicatorAcronym": "R"
        },
        {
          "DISC": 7.3950000000000005,
          "LUSCHER": 8,
          "indicatorAcronym": "V"
        }
      ],
      "sectionTitle": "Su Estilo Natural",
      "characteristics": [
        "Usted está orientado a los detalles y tiende a ser un pensador lógico lineal secuencial. No cree tan fácilmente",
        "Usted tiende a generar confianza en las personas. También A generar lealtad hacia aquellos en los cuales confía y respeta. Le gusta seguir protocolos y tener su propio ritmo.",
        "Tiende a querer tener las cosas claras todo el tiempo, como también tiende ser un pensador muy lógico y sus creencias reflejan este enfoque. Esto le podría impedir avanzar.",
        "Usted posiblemente está más cómodo(a) y relajado(a) hablando con familia y amigos cercanos que con un grupo de extraños. Tenderá a conciliar las cosas. Evita los conflictos, hay algunas batallas que es importante dar.",
        "Tiende a ser un miembro que brinda apoyo al equipo. Prefiere no ser el centro de atención. Podría ser bueno que aprenda a serlo a veces y ponerse como prioridad.",
        "Usted tiene un estilo de comportamiento fácil y adaptable, puede estar tratando de ser todo para todas las personas. Esto significa que adapta su estilo basado en la gente que lo(a) rodea.",
        "Usted aprecia la información concisa como también aquella información llena de detalles y hechos, dependiendo de sus necesidades en el momento. Buscará evitar riesgos innecesarios.",
        "Es posible que usted tienda a ser mediador(a), o sea una persona calma, por lo que no tiende a enojarse o a ser confrontacional. Le hace sentido el contener o cuidar, respetar y comprender al otro.",
        "Usted es cuidadoso e intenta enfocarse en evitar errores, equivocaciones u omisiones que usted u otros puedan cometer, así se anticipará para evitar riesos o errores. Podría también tener parálisis por análisis.",
        "Ud es perfeccionista y tomará tiempo adicional para asegurarse que su trabajo es preciso y correcto. Si ve incertidumbe en el camino hará mas de un plan para poder avanzar, o bien no hacer nada.",
        "Puede ser muy analítico y sistemático en sus relaciones y puede que no aprecie o tome en serio a los que parecen demasiado emocionales e ilógicos en su proceso de pensamiento. Podría ser bueno aprender a conectar con el otro.",
        "Es posible, que le guste observar, escuchar y conectar con otros, sabe escuchar, generar confianza y mirar desde una perspectiva un poco más amplia, lo que le permite ver cosas que otros no ven. Aunque podria tender a pensar que lo que usted ve no es relevante o importante, no se equivoque.",
        "Tiende a ser cumplidor, adheriéndose al sistema de reglas y normas establecidas. Es estructurado(a), planificado(a) y riguroso(a), lo que es su caballo de batallas, no obstante aprenda a flexibilizar, no todo es negro o blanco.",
        "Ud puede ser algo inseguro(a), por lo que no le gustan los cambios que no le aseguren nada, ya que lo(a) dejan en un espacio poco confortable, su inseguridad le puede ganar, ya que siempre tiene a poner su seguridad en cómo lo ven los demás, por tanto usted se valida por medio de otros. Tiende a compararse mucho y resistirse al cambio.",
        "Usted tiende a ser una persona conectada, empática, cuidadosa, consejera y buena persona. Tiene la capacidad para que otros se abran con uds, generando un ambiente cálido y cariñoso.",
        "Para usted hacerlo bien puede ser algo muy importante, por lo que organiza, detalla, precisa y se enfoca en todos los detalles posibles, para evitar errores.",
        "En general usted es una persona bajo perfil cauto(a), introvertido(a), prefiere pasar algo más desapercibido(a), se alinea fácilmente con las reglas y la obediencia de las leyes y la ética. Esto le podría costar salir de su zona de confort, para no arriesgar equivocarse.",
        "Es posible que usted sea una persona empática, que prioriza a los otros, le importan las personas y las relaciones armónicas. Si esto es muy reiterado, podría olvidarse de si mismo(a).",
        "Usualmente se toma más tiempo para tomar una decisión ya que se enfoca en todos los posibles resultados y luego elige el mejor.",
        "Usted sigue los procedimientos y normas reglamentarias establecidas usualmente al pie de la letra. Le podría costar el cambio.",
        "Para usted es muy importante el set de valores de una persona, familia o sistema, como también hacer lo correcto, como también evita situaciones riesgosas en dónde las reglas puedan ser quebradas.",
        "En general su capacidad para mirar las cosas desde lejos, conectar y ser pasivo(a) está muy ligado a su manera de generar conciencia sobre las cosas, pensarlas y darles espacio para luego incorporarlas. Eso sí, no sobre piense tanto, le podrían reventar en la cara.",
        "La mayoría de las veces usted piensa en los demás y podría tender a dejarse para el final, ya que tiende a priorizar a otros. Ud calla y no habla mucho, lo que también lo(a) hace un buen escuchador.",
        "Puede ser que una de sus máximas y bellas características es la de estar pendiente de lo que los otros necesitan, o bien si le piden ayuda, usted estará siempre disponible para otros, la aydua es un valor. Si es así, no olvide dejarse de lado con lo que merece."
      ],
      "categorizedCharacteristics": {
        "Miedo": {
          "subtitulo": "",
          "respuestas": [
            "Perder la seguridad y luego a ser criticado"
          ]
        },
        "Necesidad": {
          "subtitulo": "",
          "respuestas": [
            "Servir y ayudar y luego las reglas.  En general es quien implementa un plan y también lo afina"
          ]
        },
        "Su_frase_tipica": {
          "subtitulo": "",
          "respuestas": [
            "\"Yo ayudo\", piensa siempre en estar al servicio de los otros y luego piensa en \"Se cómo hacerlo\", ya que quiere calidad"
          ]
        },
        "Nombre_arquetipo": {
          "subtitulo": "",
          "respuestas": [
            "Sanador - Agua - Empatía o Ternura Silenciosa (No demuestran muchas emociones) y luego el del Soberano - Tierra - Miedo"
          ]
        },
        "paradoja_primaria": {
          "subtitulo": "",
          "respuestas": [
            "Paradoja en la que vive: la visibilidad invisible",
            "Esta paradoja es está orientada hacia atrás y es casi imperceptible, por que ronda en el silencio. Muchos de los que vivien en ella ni siquiera lo notan, o bien no la visualizan fácilmente, por lo sigilosa y transparente que es. Desde ahí ya es paradojica. Cuando mencionamos que es silenciosa, es por que los que la habitan no se dan cuenta cuando ya están atrapados en ella por completo, y el único indicador que emana, es la respiración corta, o el sentimiento de angustia primario, que tan poco es detectable, solo la ven, cuando ya se hastiaron de no haber puesto limites y el enojo emana. Ahi recién se dan cuenta lo que les pasaba, ya que al sacar la voz, deja de ser silenciosa. Su accionar es leve, es pasivo, dúctil y transformador. Este tipo de personas tienen una facilidad extraordinaria para adaptarse a otros, situaciones y eventos. La necesidad de sentir seguridad, protección, pertenecer, conectar y ser visibles para el mundo es alta, pero jamás declarada por ellos. Les mueve generar impacto o transformación en los otros, o en el mundo entero. Por tanto, se ponen al servicio de algo que sea transformacionalmente visible en la experiencia del otro. Lo interesante es que la transformación es solo visible para el otro, y en cómo el otro cambia al observar el mundo, nunca hay un elemento físico visible plasmable que evidencia el cambio, por tanto se torna invisible, solo es visible ante los ojos del otro. Les gusta apoyar, ayudar, acompañar y generar relaciones uno a uno, cercanas, profundas, donde generan confianza, intimidad y puedan sentirse vistos o reconocidos, o idealmente que los hagan sentir que ellos realmente aportan, importan y son parte de algo trascendente, como el cambio mismo. Lo interesante es comprender desde dónde lo hacen, y su gran valor es hacerlo desde el mismo silencio, al esuchar al otro, vivir y permanecer en la escucha activa, estar 100% disponible para el otro, y acompañarlo desde ahí. O bien, si lo ponemos en lenguaje paradójico es invisibilizarse (silencio) para el otro. Como son tan buenos escuchando, logran tener una tremenda mirada sistémica, estratégica y holística, del otro y de lo que sucede, atendiendo con increíbles consejos y siendo muy asertivos. Incluso cuando se entrenan no solo incluso esuchan al otro, sino que escuchan como se comportan incluso los sitemas y como estos se organizan y producen causas y efectos.  Cuando se polarizan, o sea se escuchan demasiado, se vuleven aún más hacia adentro y hacia atrás, abandonando el lugar en el cual estaban sentados y se tornan practicamente invisibles. De tanto escuchar los problemas de otros olvidan escuchar los suyos, de tanto estar en silencio olvidan hablar, de tanto querer acompañar a otros, olvidan acompañarse a sí mismos, de tanto poner a los otros primero, se ponen al final. Y, así la invisibilidad es evidente, el mundo se torna gigante y ellos minusculos, el mundo es demasiado grande y la angustia llama a la puerta, para contar que es hora de explotar y sacar fuera todo lo que e trago y no dijo. Es así como este tipo de personas que se siente invisible termina escuchando tanto para hacerse visible, que su silencio los lleva a volver al mismo punto de donde querían salir, la invisibilidad. La gran pregunta para esta persona es ¿y si te equilibras y bajas tu escuchar un poco y lo cambias por decir o sacar fuera? ¿dónde está el límite entre tú y el otro? ¿dónde empiezas tú y termina el otro? ¿cuándo te pones primero y no segundo? ¿que es lo que tú mereces? ¿cuánto necesitas ser invisible para luego explotar y visibilizarte? ¿Y sí lo haces antes? ¿sí hablas primero? ¿si te cuidas?"
          ]
        },
        "Potenciales_miedos": {
          "subtitulo": "¿Cuáles son aquellas cosas que le podrían preocupar?",
          "respuestas": [
            "Críticas de la calidad o a su trabajo",
            "Cambio constante",
            "Estando equivocado o cometiendo un error",
            "Criticar sus métodos o ritmo de trabajo"
          ]
        },
        "paradoja_secundaria": {
          "subtitulo": "",
          "respuestas": [
            "Paradoja en la que vive: la perfecta imperfección",
            "Dicen que lo imperfecto es enemigo de lo bueno, y sin duda quienes caen en esta paradoja viven desde el error y el miedo al daño que le produce la crítica cuando se equivocan. Y cómo el error es algo que evitan, buscarán siempre tener la razón o dar respuestas y evidencias que los saquen de dicho error. Los que viven en este ciclo buscan mejorar continuamente, y cada vez que mejoran algo logran ver qué les faltó, y se movilizan a mejorarlo de nuevo, y así sucesivamente. Lo que podría ser un ciclo infinito. Por tanto siempre están mirando “lo que falta“, “lo que no hay“, y no solo con lo que hacen, sino también con ellos mismos. Es así como quieren mejorar, mejorar y mejorar.  Comienzan a analizar uno, dos, tres y hasta cuaatro mil veces para estar seguros de que no se equivocarán, lo que finalmente hace que se equivoquen, ya sea por que su obsesión rígida hizo que no flexibilizara y viera una variable que estaba al lado, y debía sumar a la ecuación, o por que se obsesionaron con la exactitud, y no lograron llegar a tiempo, y el error finalmente es no cumplir. Es así como su perfección los hace imperfectos y no pueden avanzar. Cuando hay incertidumbre en el aire, o en su entorno, no son capaces de tomar decisiones, ya que sino cuentan con la información suficiente para evaluar, se paralizarán y no harán nada, lo que también puede ser parte de un error, sobre todo si tienen que cumplir con lo que se comprometiron. Los que entran en este ciclo son personas que miran desde pesimismo, viven mirando el riesgo y tienen planes por si no les resulta la primera estrategia, pueden tener una segunda, una tercera o incluso una cuarta. Son personas concretas, que necesitan reglas, marcos de referencias bien definidos e instrucciones muy claras, asi evitarán el error, y no se saldrán de lo que “deben“ hacer y pueden llegar a ser muy prisionares de ese “deber“. El deber es la consigna y no el querer. Tienden a vivir todo desde la responsabilidad, pasando muchas veces incluso a la gravedad. Para lograr el equilibrio, estas personas necesitan responderse las preguntas ¿cuánto me permito el error? ¿cuánto me permito el disfrute? ¿será que el fracaso y el error no son lo mismo? ¿será que el error es aprender? ¿cuanta gravedad tienes? ¿cúanto te permites el disfrutar? ¿y si te sales de lo establecido y aprendes?"
          ]
        },
        "Su_ambiente_preferido": {
          "subtitulo": "¿Qué tipo de ambiente(s) se adapta mejor a su estilo de comportamiento?   ",
          "respuestas": [
            "Donde la consistencia y precisión es altamente reconocido",
            "Donde la diligencia y el escrutinio se recompensa",
            "Donde a todos se les requiere trabajar dentro de un conjunto de directrices",
            "Donde la precisión es altamente valorada",
            "Donde ser enfocado en los detalles y sistemático es altamente reconocido",
            "Donde puede ser un miembro de apoyo en el equipo",
            "Donde no hay cambios injustificados",
            "Donde hay rutinas estándares y procesos establecidos",
            "Donde hay seguridad en el trabajo"
          ]
        },
        "las_personas_altas_en": {
          "subtitulo": "",
          "respuestas": [
            "Las personas altas en \"S\" son aquellas que tienen como prioridad a los otros, tienen foco en las personas, escucan al otro. Son introvertidos emocionales",
            "Las personas altas en \"C\" son aquellas que tienen como prioridad \"hacerlo bien\" con foco en el \"proceso\", son introvertidos y racionales."
          ]
        },
        "Paradoja_en_la_que_vive": {
          "subtitulo": "",
          "respuestas": []
        },
        "Comportamiento_en_el_estilo": {
          "subtitulo": "",
          "respuestas": [
            "\"Sostenedor\" o \"Consejero\" y luego es el \"Compilante\" que opera desde lo fáctico, objetivo o perfecto",
            "Esta mezcla de color verde azul habla de la posibilidad de que quizás a ud le guste ser experto en algún ámbito específico o relacionado a la evolución, biología, adapatacción, educacion, transformacion. etc"
          ]
        },
        "Motivadores_de_comportamiento": {
          "subtitulo": "¿Cuáles son algunas cosas que Ud. disfruta basado en su estilo de comportamiento?",
          "respuestas": [
            "Tener acceso a la información y datos que necesita",
            "Habiendo sido escuchado y valorado como miembro del equipo",
            "Tener establecido un ritmo de trabajo realista y los requerimientos de desempeño",
            "Tener estándares de excelencia establecidos para el trabajo a realizar"
          ]
        },
        "Potenciales_dificultades_por_uso_excesivo": {
          "subtitulo": "Una fortaleza puede transformarse en una debilidad si se usa excesivamente. Estas son algunas áreas que debe tener en cuenta.",
          "respuestas": [
            "Su comprensión de las normas de protocolo, reglas y sistemas establecidos es un recurso valioso. Sin embargo, puede alienarse de sus amigos, familia y compañeros de trabajo si está constantemente corrigiéndolos o citando las reglas. La innovación y creatividad a menudo provienen de pensar más allá del sistema actual o la manera de hacer las cosas. Apoye a otros en su exploración de enfoques alternativos (siempre y cuando no estén cruzando ningún tipo de límite legal o ético).",
            "A usted le gusta seguir rutinas/procesos establecidos y le incomoda cambiarlos a menos que hayan buenas razones para hacerlo. Mientras esto le permitirá perfeccionar un proceso y realizarlo con precisión consistente y habilidad, limita su habilidad para manejar el cambio. Intente ser más abierto a sugerencias y cuando el tiempo lo permita intente salir de su zona de confort y experimente. Puede encontrar nuevas maneras de hacer algo que sea más eficiente o incluso agradable."
          ]
        },
        "Como_otros_no_deberian_comunicarse_con_usted": {
          "subtitulo": "Esta es la forma en que a usted no le gusta que interactúen con usted.",
          "respuestas": [
            "Sean bruscos o irrespetuoso hacia usted",
            "Ignoren sus opiniones",
            "Mantengan conversaciones desenfocadas y divergentes",
            "Hagan promesas que no puedan cumplir",
            "Contradigan lo que usted tiene que decir a menos que tengan evidencia que sustente su afirmación",
            "Lo interrumpan mientras habla",
            "Lo hagan decidir algo en el momento",
            "Tengan una conversación paralela con otra persona al mismo tiempo que están hablando con usted",
            "Sean exigentes o insistan en que deje todo y comience otra cosa",
            "Cambien los temas antes de usted haber dejado claro su punto"
          ]
        },
        "Su_comportamiento_podria_reflejar_areas_como": {
          "subtitulo": "",
          "respuestas": [
            "Administración, rrhh, estartegia, soporte, atención al cliente, brand managing,consiltoría técnica, fidelización, sales farmer, psicología, biología, educación, fundaciones, ong, cooperatividad, transformación, atrología, salud, bienestar, control de gestión, analítica, exigencia estética, planificación, finanzas, biología técnica, biotecnología, etc."
          ]
        },
        "Sus_fortalezas_dado_su_estilo_de_comportamiento": {
          "subtitulo": "¿Cuáles son algunas de las palabras claves de éxito que mejor describen su estilo?",
          "respuestas": [
            "Organizado",
            "Consistente",
            "Amigable",
            "Presentando hechos",
            "Comprensivo",
            "Enfocado en los proyectos",
            "Cumplimiento de las normas",
            "Atención a los detalles"
          ]
        },
        "Bajo_estres_usted_puede_parecer_a_los_otros_como": {
          "subtitulo": "A pesar de que pueda no ser su intención, bajo estrés o presión usted puede ser percibido por otros de esta manera.",
          "respuestas": [
            "Evitando tomar decisiones",
            "Lento para reaccionar",
            "Argumentativo",
            "Prestando más atención a los detalles que lo necesario",
            "Demasiado precavido",
            "Indiferente",
            "Hablando a las personas de forma condescendiente",
            "Poco compasivo",
            "Resistente",
            "Excesivamente analítico"
          ]
        },
        "Como_le_gustaria_que_otros_se_comunicaran_con_usted": {
          "subtitulo": "Esta es la forma en que a usted le gusta que interactúen con usted.",
          "respuestas": [
            "Que sigan los protocolos de comunicación establecidos.",
            "Respeten su espacio personal cuando habla.",
            "Escuchen atentamente cuando está hablando.",
            "Hagan preguntas específicas para dar respuestas específicas.",
            "Sean directos y vayan al punto.",
            "Escuchen sus pensamientos y opiniones en su totalidad.",
            "Presenten la información y hechos de manera organizada para sustentar sus afirmaciones.",
            "Sean sinceros, auténticos y directos",
            "Le permitan el tiempo para buscar información o analizar datos antes de presentar su opinión.",
            "Asegurándose que está disponible para la conversación y no en el medio de una actividad o tarea."
          ]
        }
      }
    },
    {
      "colorPair": {
        "colorPairs": "V - AZ",
        "indicatorAcronym1": "V",
        "indicatorAcronym2": "AZ"
      },
      "sectionID": "86e49ff8-a2f0-44a2-b42c-cfb467cc0822",
      "sectionScore": [
        {
          "DISC": 4.893000000000001,
          "LUSCHER": 6,
          "indicatorAcronym": "AM"
        },
        {
          "DISC": 6.5600000000000005,
          "LUSCHER": 7,
          "indicatorAcronym": "AZ"
        },
        {
          "DISC": 2.2319999999999993,
          "LUSCHER": 3,
          "indicatorAcronym": "R"
        },
        {
          "DISC": 7.896999999999999,
          "LUSCHER": 9,
          "indicatorAcronym": "V"
        }
      ],
      "sectionTitle": "Su Estilo de Trabajo",
      "characteristics": [
        "En general, en el trabajo usted podría ser visto(a) como la persona que siempre está disponible para ayudar y abierta a ceder en post de un propósito.",
        "Tiende a ser una persona preocupada por los demás, muy colaborativa y sincera cuando otros le piden su opinión. Le gusta seguir los protocolos mientras trabaja a su propio ritmo.",
        "Para usted la eficiencia puede ser un tema, por lo que busca que cualquier interacción sea precisa, elocuente y eficaz idealmente. Ojo que podría transformarse en exigente, y a veces el fondo es más importante que la forma.",
        "Cuando hay conflictos en el trabajo, usted tiende a involucrarse y resolver los conflictos mediando, ya que es un buen conciliador. Ahora si es conflicto tiene que ver con usted, tenderá a evitarlo.",
        "Para usted es muy importante que respeten su planificación, lleguen a la hora e incluso todo pueda estar previamente definido mediante una buena carta gantt con detalles. Esa precisión suma eficiencia.",
        "En general a usted le podría gustar enfocarse mucho en los detalles y los temas específicos, lo cual le regala facticidad, certidumbre y conocimientos. No obstante, usted se siente cómodo adoptando nuevos métodos y haciendo cambios cuando están sustentados por hechos y datos.",
        "Usted quiere comenzar una tarea o proyecto y terminarlo antes de comenzar con otra cosa, en lugar de adaptarse constantemente a cambiar las metas y objetivos.",
        "Para usted es muy importante que le dejen claro hacia donde está el foco del trabajo, cual es el hilo conductor o el aporte que usted va a generar, para poder enfocar su energía hacia ese lugar. ",
        "Su ser comprensivo, buen oyente y colaborador, lo lleva a generar confianza con los miembros del equipo, es muy probable que le cuenten sus cosas o le pidan un consejo.",
        "En general cuando hay que difinir algo, usted requiere de información sumamente clara, como también podría querer detalles específicos, ya que le podría gustar ser reconocido(a) como experto.",
        "Su enfoque en las personas y al sentido de pertenencia, lo(a) lleva a siempre considerar la equidad, la justicia y la cooperación entre todos, de froma que exista armonía entre personas.",
        "Los temas éticos y hacer lo correcto puede ser un importante driver para usted, ya que siempre tiene a ser diplomático y concienzudo en lo que hace. ",
        "Cuando está el la labor del día a día, si bien se enfoca en lo suyo, está a la vez pendiente de si alguien necesita ayuda, o bien si alguien le pide ayuda usted se pondrá a disposición sin pensarlo dos veces, es un(a) apoyador innato(a).",
        "Una de sus mayores cualidades o super poder es el saber esuchar, realmente conectar con el otro, empetizar, sin juicios, logrando entender, capturar e involucrase con los demás, eso crea ambientes contenedores.",
        "Usted prefiere tener la mayor cantidad de detalles posibles cuando comienza una tarea o proyecto, asó asegura la precisión de las cosas que hace. Podría tener a querer correjir a todos, ojo con transformarse en la personas que \"todo lo sabe\"",
        "Podría tener más conexiones en el lóbulo izquierdo delantero de su cabeza, donde reside el entendimiento, la lógica y el esperar tener las cosas claras, y así disminuir la exposición o algún tipo de peligro.",
        "0Podría ser que en su cerebro hayan muchas conexiones en el lado trasero derecho, por tanto un lado emocional e introvertido, que lo puede llevar a ser paciente, perseverante y leal, ya que conecta fácil y le gusta el aprendizaje",
        "0Si bien usted puede que se muestre empático(a), tambipen podría tender a no hablar de si mismo(a),  bajando el perfil de lo que hace, sabe, idea, piensa, mostrándose humilde y modesto(a). Sin muchos cambios.",
        "Tiende a ser cumplidor, adheriéndose al sistema de reglas y normas establecidas. Es estructurado(a), planificado(a) y riguroso(a), lo que es su caballo de batallas, no obstante aprenda a flexibilizar, no todo es negro o blanco.",
        "0Si bien a usted le gusta la evolución de las cosas, la adaptación, la conciencia y lo transformador. A la vez tiende a ser alguien conservador y algo retisente al cambio.",
        "0Puede ser que una de sus máximas y bellas características es la de estar pendiente de lo que los otros necesitan, o bien si le piden ayuda, usted estará siempre disponible para otros, la aydua es un valor. Si es así, no olvide dejarse de lado con lo que merece.",
        "0Usted tiende a generar confianza en las personas, como también a generar lealtad hacia aquellos en los cuales confía y respeta.",
        "Usted es muy diplomático con otras personas y tiende a mantener la compostura bajo presión, estrés o conflictos. Ante no saber, buscará facticidades que puedan objetivar sus decisiones.",
        "Para usted el orden puede ser un gran espacio en su vida, mantener las cosas planificadas y estructuradas, ya que piensa que así logrará ser visto como alguien eficiente. Puede que a usted le sea difícil lidiar con varios proyectos a la vez. ",
        "Usualmente se toma más tiempo para tomar una decisión ya que se enfoca en todos los posibles resultados y luego elige el mejor. Se puede ver como alguien inflexible a cambio. Si analiza mucho puede incluso llegar a la parálisis por análisis.",
        "0Es posible que usted quiera comenzar una tarea o proyecto y busque terminarlo antes de comenzar con otra cosa, en lugar de adaptarse constantemente a cambiar las metas y objetivos.",
        "Usted no es típicamente de tomar riesgos y prefiere ser cauteloso en sus acciones, pero cuando se equivoca lo tiende a tomar como un fracaso o un error, más que una posibilidad de aprendizaje, ya que usted tiende a valorarse por el hacerlo bien."
      ],
      "categorizedCharacteristics": {
        "Miedo": {
          "subtitulo": "",
          "respuestas": [
            "Perder la seguridad y luego a ser criticado"
          ]
        },
        "Necesidad": {
          "subtitulo": "",
          "respuestas": [
            "Servir y ayudar y luego las reglas.  En general es quien implementa un plan y también lo afina"
          ]
        },
        "Su_frase_tipica": {
          "subtitulo": "",
          "respuestas": [
            "\"Yo ayudo\", piensa siempre en estar al servicio de los otros y luego piensa en \"Se cómo hacerlo\", ya que quiere calidad"
          ]
        },
        "Nombre_arquetipo": {
          "subtitulo": "",
          "respuestas": [
            "Sanador - Agua - Empatía o Ternura Silenciosa (No demuestran muchas emociones) y luego el del Soberano - Tierra - Miedo"
          ]
        },
        "paradoja_primaria": {
          "subtitulo": "",
          "respuestas": [
            "Paradoja en la que vive: la visibilidad invisible",
            "Esta paradoja es está orientada hacia atrás y es casi imperceptible, por que ronda en el silencio. Muchos de los que vivien en ella ni siquiera lo notan, o bien no la visualizan fácilmente, por lo sigilosa y transparente que es. Desde ahí ya es paradojica. Cuando mencionamos que es silenciosa, es por que los que la habitan no se dan cuenta cuando ya están atrapados en ella por completo, y el único indicador que emana, es la respiración corta, o el sentimiento de angustia primario, que tan poco es detectable, solo la ven, cuando ya se hastiaron de no haber puesto limites y el enojo emana. Ahi recién se dan cuenta lo que les pasaba, ya que al sacar la voz, deja de ser silenciosa. Su accionar es leve, es pasivo, dúctil y transformador. Este tipo de personas tienen una facilidad extraordinaria para adaptarse a otros, situaciones y eventos. La necesidad de sentir seguridad, protección, pertenecer, conectar y ser visibles para el mundo es alta, pero jamás declarada por ellos. Les mueve generar impacto o transformación en los otros, o en el mundo entero. Por tanto, se ponen al servicio de algo que sea transformacionalmente visible en la experiencia del otro. Lo interesante es que la transformación es solo visible para el otro, y en cómo el otro cambia al observar el mundo, nunca hay un elemento físico visible plasmable que evidencia el cambio, por tanto se torna invisible, solo es visible ante los ojos del otro. Les gusta apoyar, ayudar, acompañar y generar relaciones uno a uno, cercanas, profundas, donde generan confianza, intimidad y puedan sentirse vistos o reconocidos, o idealmente que los hagan sentir que ellos realmente aportan, importan y son parte de algo trascendente, como el cambio mismo. Lo interesante es comprender desde dónde lo hacen, y su gran valor es hacerlo desde el mismo silencio, al esuchar al otro, vivir y permanecer en la escucha activa, estar 100% disponible para el otro, y acompañarlo desde ahí. O bien, si lo ponemos en lenguaje paradójico es invisibilizarse (silencio) para el otro. Como son tan buenos escuchando, logran tener una tremenda mirada sistémica, estratégica y holística, del otro y de lo que sucede, atendiendo con increíbles consejos y siendo muy asertivos. Incluso cuando se entrenan no solo incluso esuchan al otro, sino que escuchan como se comportan incluso los sitemas y como estos se organizan y producen causas y efectos.  Cuando se polarizan, o sea se escuchan demasiado, se vuleven aún más hacia adentro y hacia atrás, abandonando el lugar en el cual estaban sentados y se tornan practicamente invisibles. De tanto escuchar los problemas de otros olvidan escuchar los suyos, de tanto estar en silencio olvidan hablar, de tanto querer acompañar a otros, olvidan acompañarse a sí mismos, de tanto poner a los otros primero, se ponen al final. Y, así la invisibilidad es evidente, el mundo se torna gigante y ellos minusculos, el mundo es demasiado grande y la angustia llama a la puerta, para contar que es hora de explotar y sacar fuera todo lo que e trago y no dijo. Es así como este tipo de personas que se siente invisible termina escuchando tanto para hacerse visible, que su silencio los lleva a volver al mismo punto de donde querían salir, la invisibilidad. La gran pregunta para esta persona es ¿y si te equilibras y bajas tu escuchar un poco y lo cambias por decir o sacar fuera? ¿dónde está el límite entre tú y el otro? ¿dónde empiezas tú y termina el otro? ¿cuándo te pones primero y no segundo? ¿que es lo que tú mereces? ¿cuánto necesitas ser invisible para luego explotar y visibilizarte? ¿Y sí lo haces antes? ¿sí hablas primero? ¿si te cuidas?"
          ]
        },
        "Potenciales_miedos": {
          "subtitulo": "¿Cuáles son aquellas cosas que le podrían preocupar?",
          "respuestas": [
            "Críticas de la calidad o a su trabajo",
            "Cambio constante",
            "Estando equivocado o cometiendo un error",
            "Criticar sus métodos o ritmo de trabajo"
          ]
        },
        "paradoja_secundaria": {
          "subtitulo": "",
          "respuestas": [
            "Paradoja en la que vive: la perfecta imperfección",
            "Dicen que lo imperfecto es enemigo de lo bueno, y sin duda quienes caen en esta paradoja viven desde el error y el miedo al daño que le produce la crítica cuando se equivocan. Y cómo el error es algo que evitan, buscarán siempre tener la razón o dar respuestas y evidencias que los saquen de dicho error. Los que viven en este ciclo buscan mejorar continuamente, y cada vez que mejoran algo logran ver qué les faltó, y se movilizan a mejorarlo de nuevo, y así sucesivamente. Lo que podría ser un ciclo infinito. Por tanto siempre están mirando “lo que falta“, “lo que no hay“, y no solo con lo que hacen, sino también con ellos mismos. Es así como quieren mejorar, mejorar y mejorar.  Comienzan a analizar uno, dos, tres y hasta cuaatro mil veces para estar seguros de que no se equivocarán, lo que finalmente hace que se equivoquen, ya sea por que su obsesión rígida hizo que no flexibilizara y viera una variable que estaba al lado, y debía sumar a la ecuación, o por que se obsesionaron con la exactitud, y no lograron llegar a tiempo, y el error finalmente es no cumplir. Es así como su perfección los hace imperfectos y no pueden avanzar. Cuando hay incertidumbre en el aire, o en su entorno, no son capaces de tomar decisiones, ya que sino cuentan con la información suficiente para evaluar, se paralizarán y no harán nada, lo que también puede ser parte de un error, sobre todo si tienen que cumplir con lo que se comprometiron. Los que entran en este ciclo son personas que miran desde pesimismo, viven mirando el riesgo y tienen planes por si no les resulta la primera estrategia, pueden tener una segunda, una tercera o incluso una cuarta. Son personas concretas, que necesitan reglas, marcos de referencias bien definidos e instrucciones muy claras, asi evitarán el error, y no se saldrán de lo que “deben“ hacer y pueden llegar a ser muy prisionares de ese “deber“. El deber es la consigna y no el querer. Tienden a vivir todo desde la responsabilidad, pasando muchas veces incluso a la gravedad. Para lograr el equilibrio, estas personas necesitan responderse las preguntas ¿cuánto me permito el error? ¿cuánto me permito el disfrute? ¿será que el fracaso y el error no son lo mismo? ¿será que el error es aprender? ¿cuanta gravedad tienes? ¿cúanto te permites el disfrutar? ¿y si te sales de lo establecido y aprendes?"
          ]
        },
        "Su_ambiente_preferido": {
          "subtitulo": "¿Qué tipo de ambiente(s) se adapta mejor a su estilo de comportamiento?   ",
          "respuestas": [
            "Donde la consistencia y precisión es altamente reconocido",
            "Donde la diligencia y el escrutinio se recompensa",
            "Donde a todos se les requiere trabajar dentro de un conjunto de directrices",
            "Donde la precisión es altamente valorada",
            "Donde ser enfocado en los detalles y sistemático es altamente reconocido",
            "Donde puede ser un miembro de apoyo en el equipo",
            "Donde no hay cambios injustificados",
            "Donde hay rutinas estándares y procesos establecidos",
            "Donde hay seguridad en el trabajo"
          ]
        },
        "las_personas_altas_en": {
          "subtitulo": "",
          "respuestas": [
            "Las personas altas en \"S\" son aquellas que tienen como prioridad a los otros, tienen foco en las personas, escucan al otro. Son introvertidos emocionales",
            "Las personas altas en \"C\" son aquellas que tienen como prioridad \"hacerlo bien\" con foco en el \"proceso\", son introvertidos y racionales."
          ]
        },
        "Paradoja_en_la_que_vive": {
          "subtitulo": "",
          "respuestas": []
        },
        "Comportamiento_en_el_estilo": {
          "subtitulo": "",
          "respuestas": [
            "\"Sostenedor\" o \"Consejero\" y luego es el \"Compilante\" que opera desde lo fáctico, objetivo o perfecto",
            "Esta mezcla de color verde azul habla de la posibilidad de que quizás a ud le guste ser experto en algún ámbito específico o relacionado a la evolución, biología, adapatacción, educacion, transformacion. etc"
          ]
        },
        "Motivadores_de_comportamiento": {
          "subtitulo": "¿Cuáles son algunas cosas que Ud. disfruta basado en su estilo de comportamiento?",
          "respuestas": [
            "Tener acceso a la información y datos que necesita",
            "Habiendo sido escuchado y valorado como miembro del equipo",
            "Tener establecido un ritmo de trabajo realista y los requerimientos de desempeño",
            "Tener estándares de excelencia establecidos para el trabajo a realizar"
          ]
        },
        "Potenciales_dificultades_por_uso_excesivo": {
          "subtitulo": "Una fortaleza puede transformarse en una debilidad si se usa excesivamente. Estas son algunas áreas que debe tener en cuenta.",
          "respuestas": [
            "Su comprensión de las normas de protocolo, reglas y sistemas establecidos es un recurso valioso. Sin embargo, puede alienarse de sus amigos, familia y compañeros de trabajo si está constantemente corrigiéndolos o citando las reglas. La innovación y creatividad a menudo provienen de pensar más allá del sistema actual o la manera de hacer las cosas. Apoye a otros en su exploración de enfoques alternativos (siempre y cuando no estén cruzando ningún tipo de límite legal o ético).",
            "A usted le gusta seguir rutinas/procesos establecidos y le incomoda cambiarlos a menos que hayan buenas razones para hacerlo. Mientras esto le permitirá perfeccionar un proceso y realizarlo con precisión consistente y habilidad, limita su habilidad para manejar el cambio. Intente ser más abierto a sugerencias y cuando el tiempo lo permita intente salir de su zona de confort y experimente. Puede encontrar nuevas maneras de hacer algo que sea más eficiente o incluso agradable."
          ]
        },
        "Como_otros_no_deberian_comunicarse_con_usted": {
          "subtitulo": "Esta es la forma en que a usted no le gusta que interactúen con usted.",
          "respuestas": [
            "Sean bruscos o irrespetuoso hacia usted",
            "Ignoren sus opiniones",
            "Mantengan conversaciones desenfocadas y divergentes",
            "Hagan promesas que no puedan cumplir",
            "Contradigan lo que usted tiene que decir a menos que tengan evidencia que sustente su afirmación",
            "Lo interrumpan mientras habla",
            "Lo hagan decidir algo en el momento",
            "Tengan una conversación paralela con otra persona al mismo tiempo que están hablando con usted",
            "Sean exigentes o insistan en que deje todo y comience otra cosa",
            "Cambien los temas antes de usted haber dejado claro su punto"
          ]
        },
        "Su_comportamiento_podria_reflejar_areas_como": {
          "subtitulo": "",
          "respuestas": [
            "Administración, rrhh, estartegia, soporte, atención al cliente, brand managing,consiltoría técnica, fidelización, sales farmer, psicología, biología, educación, fundaciones, ong, cooperatividad, transformación, atrología, salud, bienestar, control de gestión, analítica, exigencia estética, planificación, finanzas, biología técnica, biotecnología, etc."
          ]
        },
        "Sus_fortalezas_dado_su_estilo_de_comportamiento": {
          "subtitulo": "¿Cuáles son algunas de las palabras claves de éxito que mejor describen su estilo?",
          "respuestas": [
            "Organizado",
            "Consistente",
            "Amigable",
            "Presentando hechos",
            "Comprensivo",
            "Enfocado en los proyectos",
            "Cumplimiento de las normas",
            "Atención a los detalles"
          ]
        },
        "Bajo_estres_usted_puede_parecer_a_los_otros_como": {
          "subtitulo": "A pesar de que pueda no ser su intención, bajo estrés o presión usted puede ser percibido por otros de esta manera.",
          "respuestas": [
            "Evitando tomar decisiones",
            "Lento para reaccionar",
            "Argumentativo",
            "Prestando más atención a los detalles que lo necesario",
            "Demasiado precavido",
            "Indiferente",
            "Hablando a las personas de forma condescendiente",
            "Poco compasivo",
            "Resistente",
            "Excesivamente analítico"
          ]
        },
        "Como_le_gustaria_que_otros_se_comunicaran_con_usted": {
          "subtitulo": "Esta es la forma en que a usted le gusta que interactúen con usted.",
          "respuestas": [
            "Que sigan los protocolos de comunicación establecidos.",
            "Respeten su espacio personal cuando habla.",
            "Escuchen atentamente cuando está hablando.",
            "Hagan preguntas específicas para dar respuestas específicas.",
            "Sean directos y vayan al punto.",
            "Escuchen sus pensamientos y opiniones en su totalidad.",
            "Presenten la información y hechos de manera organizada para sustentar sus afirmaciones.",
            "Sean sinceros, auténticos y directos",
            "Le permitan el tiempo para buscar información o analizar datos antes de presentar su opinión.",
            "Asegurándose que está disponible para la conversación y no en el medio de una actividad o tarea."
          ]
        }
      }
    },
    {
      "sectionID": "99c5a963-6bd4-4552-89ec-03bbab9f2db4",
      "sectionScore": [
        {
          "DISC": 4.753,
          "indicatorAcronym": "EST"
        },
        {
          "DISC": 8.391000000000002,
          "indicatorAcronym": "REC"
        },
        {
          "DISC": 7.213999999999999,
          "indicatorAcronym": "AY"
        },
        {
          "DISC": 7.106999999999998,
          "indicatorAcronym": "DES"
        },
        {
          "DISC": 2.399,
          "indicatorAcronym": "LID"
        },
        {
          "DISC": 6.893000000000001,
          "indicatorAcronym": "PAZ"
        },
        {
          "DISC": 1.7570000000000001,
          "indicatorAcronym": "INV"
        }
      ],
      "sectionTitle": "Motivadores Parte 1"
    },
    {
      "sectionID": "4806552e-fc01-43b9-8d35-9f4fc8b83a9f",
      "sectionScore": [
        {
          "phrase": "Yo valoror mi sistema personal de creencias (filosófico, religioso, espiritual) más que todo",
          "indicatorAcronym": "REC"
        }
      ],
      "sectionTitle": "Motivadores Parte 2"
    }
  ],
  "updatedAt": "2023-01-19T19:46:32.193Z"
}

const CustomChart = () => (<Charts data={chartData} />)

export default CustomChart;